'use client';

import { c as _c } from "react/compiler-runtime";
import { type FC, useCallback } from 'react';
interface FilterTagsProps {
  selectedTag?: string;
  onTagSelect?: (tag: string) => void;
  tags: string[] | {
    title: string;
    value: string;
  }[];
  screen?: boolean;
}
export const FilterTags: FC<FilterTagsProps> = t0 => {
  const $ = _c(15);
  const {
    tags,
    selectedTag,
    onTagSelect,
    screen: t1
  } = t0;
  const screen = t1 === undefined ? true : t1;
  const handleWheel = _temp;
  let t2;
  if ($[0] !== onTagSelect || $[1] !== selectedTag || $[2] !== tags) {
    t2 = tag => {
      if (typeof tag === "string") {
        return <div key={tag} className="inline-flex shrink-0 first:pl-4 last:pr-4"><button onClick={() => onTagSelect?.(tag)} className={`
        inline-flex shrink-0
        pt-0.5 text-base leading-[1.4] md:pt-3 md:text-[22px]
        ${(selectedTag || tags.at(0)) === tag ? "border-b-2 border-[#2A72FD] font-semibold text-[#E9ECF0]" : "font-medium text-[#A0A3E2]"}
      `}>{tag.replaceAll("_", " ")}</button></div>;
      } else {
        return <div key={tag.value} className="first:pl-4 last:pr-4 inline-flex shrink-0"><button onClick={() => onTagSelect?.(tag.value)} className={`
          inline-flex shrink-0
          items-center justify-center gap-2 whitespace-nowrap rounded-[100px] px-4 py-2 pb-[11px]
          pt-2.5 font-['Inter'] text-[14px] font-normal capitalize leading-normal text-[#e9ecf0] md:text-[22px]
          ${selectedTag === tag.value ? "bg-[#20202e]" : "border border-[#20202e]"}
        `}>{tag.title.replaceAll("_", " ")}</button></div>;
      }
    };
    $[0] = onTagSelect;
    $[1] = selectedTag;
    $[2] = tags;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const renderTagButton = t2;
  const t3 = "scrollbar-hide relative -mx-4 overflow-x-auto " + (screen ? "w-screen" : "w-[calc(100%+32px)]");
  const t4 = "flex h-8 flex-nowrap justify-between md:h-16 md:justify-start " + (screen ? "gap-5 md:gap-8" : "gap-2 md:gap-3");
  let t5;
  if ($[4] !== renderTagButton || $[5] !== tags) {
    let t6;
    if ($[7] !== renderTagButton) {
      t6 = tag_0 => renderTagButton(tag_0);
      $[7] = renderTagButton;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    t5 = tags.map(t6);
    $[4] = renderTagButton;
    $[5] = tags;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <div className={t4}>{t5}</div>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t6) {
    t7 = <div className={t3} onWheel={handleWheel}>{t6}</div>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
function _temp(e) {
  if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
    e.currentTarget.scrollLeft = e.currentTarget.scrollLeft + e.deltaY;
    e.preventDefault();
  }
}